import type { HREmployee } from '@/api/client'
import { cn } from '@/lib/cn'

type EmployeeLike = Pick<HREmployee, 'first_name' | 'last_name' | 'photo_url'>

type Size = 'sm' | 'md' | 'lg' | 'xl'

const sizeClasses: Record<Size, string> = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-14 w-14 text-base',
  xl: 'h-20 w-20 text-xl',
}

function initials(e: EmployeeLike): string {
  const first = e.first_name?.[0] ?? ''
  const last = e.last_name?.[0] ?? ''
  const combined = (first + last).toUpperCase()
  return combined || '?'
}

interface Props {
  employee: EmployeeLike
  size?: Size
  className?: string
}

export function EmployeeAvatar({ employee, size = 'md', className }: Props) {
  const classes = cn(
    'inline-flex shrink-0 select-none items-center justify-center rounded-full font-semibold',
    sizeClasses[size],
    className,
  )
  if (employee.photo_url) {
    return (
      <img
        src={employee.photo_url}
        alt={`${employee.first_name} ${employee.last_name}`}
        className={cn(classes, 'object-cover')}
      />
    )
  }
  return (
    <div
      className={cn(classes, 'bg-muted text-foreground')}
      aria-hidden="true"
    >
      {initials(employee)}
    </div>
  )
}
